<div class="input-group input-group-sm">
    <spv2-efile-submission-status-dropdown [(value)]="value" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" [isMultiSelect]="true" [multiSelectSettings]="{isGridFilter: true}"></spv2-efile-submission-status-dropdown>
</div>